"use client"

import { Translation } from "@/components/Translation/Translation.component"

export function ConsentLink() {
  return (
    <button
      className="footer-link"
      onClick={() => {
        if (typeof Cookiebot !== "undefined") {
          Cookiebot.show()
        }
      }}
      type="button"
    >
      <Translation
        model={{
          da: "Administrér samtykke",
          de: "Cookie-Einstellungen anpassen",
          en: "Manage consent",
          no: "Administrér samtykke",
          sv: "Hantera samtycke",
        }}
      />
    </button>
  )
}
